export default "__VITE_ASSET__BytquBZE__"